import { BudgetRequestRepository } from '@/models/BudgetRequest'
// import { MenuRequestRepository } from '@/models/MenuRequest'
// import { AgencyMarginRequestRepository } from '@/models/AgencyMarginRequest'
import { MapReportListRepository } from '@/models/MapReport/MapReportListRepository'

export default {
  async FETCH_COUNT({ commit }, { systemOwnerId }) {
    const requestStatus = 'waiting'
    const [
      budgetResult,
      // menuResult,
      // agencyMarginResult,
    ] = await Promise.all([
      BudgetRequestRepository.search({
        requestStatus,
        systemOwnerId,
      }),
      // MenuRequestRepository.search({ requestStatus, systemOwnerId }),
      // AgencyMarginRequestRepository.search({ requestStatus, systemOwnerId }),
    ])

    commit('SET_REQUEST_COUNT', {
      budgetRequest: budgetResult.count,
      // menuRequest: menuResult.count,
      // agencyMarginRequest: agencyMarginResult.count,
    })
  },
  async FETCH_MAP_REPORT_COUNT({ commit }) {
    const mapReportCount = await MapReportListRepository.getMapReportRequestCountForAdmin()

    commit('SET_MAP_REPORT_REQUEST_COUNT', {
      mapReportRequest: mapReportCount,
    })
  },
  RESET({ commit }) {
    commit('RESET')
  },
}
